import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./i18n";
import App from "./App";

import reportWebVitals from "./reportWebVitals";

// Preload Google Maps Places library once on app start to avoid first-load race conditions
const preloadGoogleMapsPlaces = () => {
  if (typeof window === 'undefined') return;
  if (window.google && window.google.maps && window.google.maps.places) return;
  const existing = document.querySelector('script[data-gmaps="true"]');
  if (existing) return;
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    console.warn('[Places] Missing REACT_APP_GOOGLE_MAPS_API_KEY');
    return;
  }
  const script = document.createElement('script');
  script.setAttribute('data-gmaps', 'true');
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&v=weekly&loading=async`;
  script.async = true;
  script.defer = true;
  script.onload = async () => {
    try {
      // Ensure places library is actually initialized for the new web components
      // @ts-ignore
      await window.google.maps.importLibrary('places');
      if (typeof window.customElements?.whenDefined === 'function') {
        try {
          await window.customElements.whenDefined('gmp-place-autocomplete');
        } catch (e) {}
      }
      console.log('[Places] preloaded');
    } catch (e) {
      console.error('[Places] preload error:', e);
    }
  };
  document.head.appendChild(script);
};

preloadGoogleMapsPlaces();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
